export const alertConstants = {
    SEND_ALERT_SUCCESS: 'SEND_ALERT_SUCCESS',
    SEND_ALERT_FAILURE: 'SEND_ALERT_FAILURE',
    SEND_ALERT_REQUEST: 'SEND_ALERT_REQUEST'

};